import { InvoiceConstants } from "utils/constants";
import { InvoiceHelper } from "utils/helpers";

function useReminderValues() {
  const getReminderValues = (
    paymentReminderEmailMessageTemplate?: string,
    paymentReminderTitleTemplate?: string,
    paymentReminderMessageTemplate?: string,
    serialNumber?: number
  ) => {
    const defaultReminderDateDiff = 10;
    const reminderTitleTemplate =
      paymentReminderTitleTemplate?.replace(
        InvoiceConstants.SerialNumberTemplateValue,
        serialNumber ? InvoiceHelper.formatInvoiceNumber(serialNumber) : ""
      ) ?? "";

    const reminderEmailMessageTemplate =
      paymentReminderEmailMessageTemplate?.replace(
        InvoiceConstants.SerialNumberTemplateValue,
        serialNumber ? InvoiceHelper.formatInvoiceNumber(serialNumber) : ""
      ) ?? "";

    const reminderMessageTemplate = paymentReminderMessageTemplate ?? "";

    return {
      defaultReminderDateDiff,
      reminderTitleTemplate,
      reminderEmailMessageTemplate,
      reminderMessageTemplate,
    };
  };

  return { getReminderValues };
}

export default useReminderValues;
